import React, { useContext, useState } from "react";
import ModalUI from "../ui/ModalUI";
import { useFormik } from "formik";
import { updateProjectBudget } from "../../api/Api"; 
import { showToast } from "../../utils/toastUtils";
import ShortTextInput from "../Inputs/ShortTextInput";
import CustomSelectBox from "../Inputs/CustomSelectBox";
import CustomButton from "../CustomButton";
import * as Yup from "yup";
import { CURRENCY_OPTIONS } from "../../constants/constant";

const BudgetEditSchema = Yup.object().shape({
  budget: Yup.number().required("Budget is required").min(0, "Must be >= 0"),
  balance: Yup.number().required("Balance is required").min(0, "Must be >= 0"),
  currency: Yup.string().required("Currency is required"),
});

function UpdateBudgetModal({ show, handleClose, project, refresh }) {
  const [currency, setCurrency] = useState(project?.currency || "USD");

  const formik = useFormik({
    initialValues: {
      budget: project?.budget || "0.00",
      balance: project?.balance || "0.00",
      currency: project?.currency || "USD",
    },
    validationSchema: BudgetEditSchema,
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting }) => {
      handleUpdate(values, setSubmitting);
    },
  });

  const handleUpdate = async (values, setSubmitting) => {
    try {
      const response = await updateProjectBudget(project.id, values);
      if (response?.status === 200) {
        showToast("Budget updated successfully", "success");
        handleClose();
        refresh();
      } else {
        showToast("Update failed", "error");
      }
    } catch (error) {
      console.error("Update error:", error);
      showToast("Something went wrong", "error");
    } finally {
      setSubmitting(false);
    }
  };

  const handleCurrencyChange = (e) => {
    setCurrency(e.target.value);
    formik.setFieldValue("currency", e.target.value);
  };

  const getCurrencySymbol = (currency) => {
    const option = CURRENCY_OPTIONS.find(c => c.value === currency);
    return option ? option.symbol : "";
  }

  return (
    <ModalUI show={show} handleClose={handleClose} title="Update Project Budget">
      <form onSubmit={formik.handleSubmit}>
        <CustomSelectBox
          id="currency"
          name="currency"
          label="Currency"
          options={CURRENCY_OPTIONS}
          value={formik.values.currency}
          onChange={handleCurrencyChange}
          error={formik.touched.currency && formik.errors.currency}
          placeholder="Select Currency"
          fullWidth
        />
        
        <ShortTextInput
          id="budget"
          name="budget"
          label="Total Budget"
          type="number"
          value={formik.values.budget}
          onChange={formik.handleChange}
          error={formik.touched.budget && formik.errors.budget}
          prefix={getCurrencySymbol(formik.values.currency)}
        />
        <ShortTextInput
          id="balance"
          name="balance"
          label="Total Spent Amount"
          type="number"
          value={formik.values.balance}
          onChange={formik.handleChange}
          error={formik.touched.balance && formik.errors.balance}
          prefix={getCurrencySymbol(formik.values.currency)}
        />
        <div className="d-flex justify-content-center p-3">
          <CustomButton type="submit" disabled={formik.isSubmitting}>
            Update Budget
          </CustomButton>
        </div>
      </form>
    </ModalUI>
  );
}

export default UpdateBudgetModal;
